<template>
  <div>
    <page-form
      ref="baseFormRef"
      :isProfile="true"
      :baseFormConfig="baseFormConfig"
      @handleNewClick="handleSubmitClick"
      :pageTitle="$t('profile.my-profile-title')"
      :pageInfo="pageInfo"
      :isResetFields="false"
    >
      <template #otherFooter>
        <el-button
          v-if="isChange"
          icon="el-icon-edit"
          @click="handleChangePassword"
          size="small"
          >{{ $t('general.changePassword') }}</el-button
        >
      </template>
    </page-form>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue'
import pageForm from '@/components/PageForm/page-form.vue'
import { baseFormConfig } from './config/profile.form.js'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { cloneDeep } from 'lodash'
import { usePermission } from '@/hooks/use-permission'

const store = useStore()
const router = useRouter()
// const routes = useRoute()
const { appContext } = getCurrentInstance()
const handleMessageCommit =
  appContext.config.globalProperties.$handleMessageCommit

const pageInfo = ref({})

const isChange = usePermission('system', 'profile', 'change')

const getPageInfo = async () => {
  const res = await store.dispatch('user/getUserInfo')
  const showInfo = res?.data?.data || {}
  pageInfo.value = showInfo
}

const handleSubmitClick = async (data) => {
  const form = cloneDeep(data)
  // form.avatarUrl = store.state.system.imgPathList[routes.path]
  handleMessageCommit('user/handleUpdateProfile', form).then(() => {
    getPageInfo()
  })
}
const handleChangePassword = () => {
  router.push('/system/profile/changePassword')
}

getPageInfo()
</script>
